import React from 'react';
import styled from 'styled-components';
import Box from '../../../../shared/components/Box';
import ContentSideFeature from '../../../../shared/components/ContentSideFeature';
import Heading from '../../../../shared/components/Heading';
import { NarrowParagraph } from '../../../../shared/components/Paragraph';
import { media, typography } from '../../../../shared/lib/styles';

export interface Props {
    count: number;
    title: string;
    description: string;
    reducedDefaultFontSize?: boolean;
}

const Count = styled.div<{ reducedDefaultFontSize: boolean }>(({ reducedDefaultFontSize }) => {
    let defaultFontSize = '270px';

    if (reducedDefaultFontSize) defaultFontSize = '190px';

    return `
        font-family: ${typography.fontFamilies.heading};
        font-weight: ${typography.fontWeights.heading};
        letter-spacing: ${typography.letterSpacing.h1};
        font-size: ${defaultFontSize};
        line-height: 300px;
        margin-bottom: 0px;

        @media ${media('medium')} {
            font-size: 200px;
            line-height: 200px;
        }

        @media ${media('small')} {
            font-size: 80px;
            line-height: 80px;
        }
    `;
});

function StatsItem({ count, title, description, reducedDefaultFontSize = false }: Props) {
    return (
        <Box textAlign="left">
            <ContentSideFeature
                variations={['side-feature-top', 'centered-stacked-small']}
                side={
                    <Box paddingRight={['space10', 'space10', 'space10', 'space10']}>
                        <Count reducedDefaultFontSize={reducedDefaultFontSize}>{count}</Count>
                    </Box>
                }
                top={
                    <Box paddingBottom={['space7', 'space7', 'space7', 'space7']}>
                        <Heading type="h3" variations={['h1', 'no-margin']}>
                            {title}
                        </Heading>
                    </Box>
                }
                bottom={<NarrowParagraph>{description}</NarrowParagraph>}
            />
        </Box>
    );
}

export default StatsItem;
